module.exports = __webpack_public_path__ + "img/workspace-onboarding/invite-your-team-f9273c7886022ff22becdd4d2cc16dd2.png";